/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 利用者種別
 * @export
 * @enum {number}
 */
export enum AccountRoleEnum {
    /** 全権管理者 */
    ADMIN = 1,
    /** 組織管理者 */
    ORGANIZATION_ADMIN = 2,
    /** 一般 */
    GENERAL = 3
}

/**
 * 利用者種別 の Union 型
 * @export
 * @typedef AccountRole
 */
export type AccountRole =
  typeof AccountRoleEnum[keyof typeof AccountRoleEnum];

/**
 * 利用者種別 のラベルマップ
 * @export
 */
export const AccountRoleLabels = {
    /**
     * 数値キー: AccountRoleEnum.ADMIN
     * 名前キー:  ADMIN
     */
    [AccountRoleEnum.ADMIN]: '全権管理者',
    ADMIN:                             '全権管理者',
    /**
     * 数値キー: AccountRoleEnum.ORGANIZATION_ADMIN
     * 名前キー:  ORGANIZATION_ADMIN
     */
    [AccountRoleEnum.ORGANIZATION_ADMIN]: '組織管理者',
    ORGANIZATION_ADMIN:                             '組織管理者',
    /**
     * 数値キー: AccountRoleEnum.GENERAL
     * 名前キー:  GENERAL
     */
    [AccountRoleEnum.GENERAL]: '一般',
    GENERAL:                             '一般',
} as const;

/**
 * 利用者種別 のラベル Union 型
 * @export
 * @typedef AccountRoleLabel
 */
export type AccountRoleLabel =
  typeof AccountRoleLabels[keyof typeof AccountRoleLabels];

/**
 * 利用者種別 のラベル取得関数
 * @export
 * @param { AccountRole } value - 列挙体の値
 * @returns { AccountRoleLabel } ラベル文字列
 */
export function getAccountRoleLabel(
  value: AccountRole
): AccountRoleLabel {
  return AccountRoleLabels[value];
}

/**
 * 利用者種別 のラベル配列を取得する関数
 * @export
 * @param { AccountRole[] } values - 列挙体の値配列
 * @returns { AccountRoleLabel[] } ラベル文字列配列
 */
export function getAccountRoleLabels(values: AccountRole[]): AccountRoleLabel[] {
  return values.map((value) => getAccountRoleLabel(value));
}

/**
 * 利用者種別 のラベル配列
 * @export
 */
export const AccountRoleLabelList = [
  '全権管理者','組織管理者','一般',
] as const;

